import styled from 'styled-components'

export default styled.div`
  .main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .MuiCircularProgress-colorPrimary {
      color: ${(props) => props.theme.color};
    }
  }

  form {
    width: 470px;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;

    div {
      margin-right: 5px;

      &:last-child {
        margin-right: 0px;
      }

    }
  }

  .form-buttons {
    margin-top: 1rem;
  }

  .first-line {
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .requests-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .MuiCircularProgress-root {
      width: initial !important;
      height: initial !important;

      svg {
        margin-right: 0px;
        width: 17px;
      }
    }
  }

  .counter {
    font-weight: bold;
    font-size: 17px;
  }

  .table {
    width: 100%;

    thead {
      tr {
        th {
          padding: 0.4rem;
          font-size: 0.8rem;
          border-top: none;
          border-bottom: 2px solid ${(props) => props.theme.palette.gray[300]};

          &.middle-col {
            white-space: break-spaces;
            min-width: 50px;
            max-width: 52px;
          }
        }

        &:first-child {
          border-left: none;
        }

        &:last-child {
          border-right: none;
        }
      }
    }

    tbody {
      border-left: none;
      border-right: none;

      tr {
        border-bottom: 1px solid ${(props) => props.theme.palette.gray[200]};

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          .sticky-col {
            background-color: #F5F5F5;
          }
        }

        td {
          padding: 0.1rem;
        }
      }
    }
  }

  .status {
    color: ${(props) => props.theme.color};
    display: flex;
    align-items: center;
  }

  .status-value {
    margin-right: 5px;
  }

  .button-size {
    width: 200px;
  }

  .button-close {
    margin-left: 30px;
  }

  .sticky-col {
    position: sticky;
    position: -webkit-sticky;
    background-color: white;
  }

  .sticky-th {
    position: sticky;
    background-color: white;
    top: 0;
    z-index: 99;
  }

  .cell-separator {
    min-width: 30px;
    visibility: hidden;
  }

  .wrapper {
    margin-top: 30px;
    border: 2px solid ${(props) => props.theme.palette.gray[300]};
    border-top: 3px solid ${(props) => props.theme.color};
    position: relative;
    overflow: auto;
    white-space: nowrap;
    // max-height 75vh;

    ::-webkit-scrollbar-track {
      background-color: #F4F4F4;
    }
    ::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      height: 10px;
    }

    ::-webkit-scrollbar::hover {
      height: 15px;
    }

    ::-webkit-scrollbar-thumb {
      background: #dad7d7;
    }
  }

  .filters-container {
    display: flex;
  }

  .view {
    margin: auto;
    width: 100%;

    .loader-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
    }
  }

  .first-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 0px;
  }

  .last-col {
    padding-left: 15px !important;
    padding-right: 15px !important;
    right: 0px;
  }

  .first-th {
    z-index: 999;
  }

  .handler {
    cursor: pointer;
  }

  .icon-button {
    cursor: pointer;
  }

  .search {
    button {
      font-size: 14px;
    }
  }
`
